import axios from 'axios';
import config from 'config.js';

/* -------------------------------------------------------------------------- */
/*                              ENDPOINT STATUSES                             */
/* -------------------------------------------------------------------------- */

const getEndpointStatus = (type) => {
  const types = {
    request: {
      loading: true,
      error: false,
      success: false
    },
    success: {
      loading: false,
      error: false,
      success: true
    },
    failure: {
      loading: false,
      error: true,
      success: false
    }
  };

  return (
    types[type] || {
      loading: false,
      error: false,
      success: false
    }
  );
};

/* -------------------------------------------------------------------------- */
/*                                    STATE                                   */
/* -------------------------------------------------------------------------- */

const initialState = {
  customCodeForms: [],

  getFormsWithCustomCode: { ...getEndpointStatus() },
  markFormWithCustomCodeAsChecked: { ...getEndpointStatus() }
};

/* -------------------------------------------------------------------------- */
/*                                STATE REDUCER                               */
/* -------------------------------------------------------------------------- */

const GET_CUSTOM_CODE_FORMS_REQUEST = 'customCode/GET_POTENTIAL_SCAM_REQUEST';
const GET_CUSTOM_CODE_FORMS_SUCCESS = 'customCode/GET_POTENTIAL_SCAM_SUCCESS';
const GET_CUSTOM_CODE_FORMS_FAILURE = 'customCode/GET_POTENTIAL_SCAM_FAILURE';

const MARK_FORM_WITH_CUSTOM_CODE_AS_CHECKED_REQUEST = 'customCode/MARK_FORM_WITH_CUSTOM_CODE_AS_CHECKED_REQUEST';
const MARK_FORM_WITH_CUSTOM_CODE_AS_CHECKED_SUCCESS = 'customCode/MARK_FORM_WITH_CUSTOM_CODE_AS_CHECKED_SUCCESS';
const MARK_FORM_WITH_CUSTOM_CODE_AS_CHECKED_FAILURE = 'customCode/MARK_FORM_WITH_CUSTOM_CODE_AS_CHECKED_FAILURE';

export default function reducer(state = JSON.parse(JSON.stringify(initialState)), action = {}) {
  // getting forms
  if (action.type === GET_CUSTOM_CODE_FORMS_REQUEST) {
    state.getFormsWithCustomCode = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === GET_CUSTOM_CODE_FORMS_SUCCESS) {
    state.getFormsWithCustomCode = getEndpointStatus('success');
    state.customCodeForms = action.payload;

    return { ...state };
  }

  if (action.type === GET_CUSTOM_CODE_FORMS_FAILURE) {
    state.getFormsWithCustomCode = getEndpointStatus('failure');

    return { ...state };
  }

  // marking
  if (action.type === MARK_FORM_WITH_CUSTOM_CODE_AS_CHECKED_REQUEST) {
    state.markFormWithCustomCodeAsChecked = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === MARK_FORM_WITH_CUSTOM_CODE_AS_CHECKED_SUCCESS) {
    state.markFormWithCustomCodeAsChecked = getEndpointStatus('success');
    const formChanges = action.payload;


    return {
      ...state,
      customCodeForms: state.customCodeForms.map((form) => {
        if (formChanges._id && String(form._id) === String(formChanges._id)) {
          delete formChanges._id;

          return {
            ...form,
            ...formChanges
          };
        } else {
          return form;
        }
      })
    };
  }

  if (action.type === MARK_FORM_WITH_CUSTOM_CODE_AS_CHECKED_FAILURE) {
    state.markFormWithCustomCodeAsChecked = getEndpointStatus('failure');

    return { ...state };
  }

  return state;
}

/* -------------------------------------------------------------------------- */
/*                                  API CALLS                                 */
/* -------------------------------------------------------------------------- */

const services = {
  getFormsWithCustomCode: async () => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/api/admin/customCode/forms`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },

  markFormWithCustomCodeAsChecked: async (data) => {
    try {
      const response = await axios({
        method: 'POST',
        url: `${config.apiUrl}/api/admin/customCode/validateForm`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('user_token')}`
        },
        data
      });

      return response;
    } catch (e) {
      return e.response;
    }
  }
};

/* -------------------------------------------------------------------------- */
/*                                  REDUCERS                                  */
/* -------------------------------------------------------------------------- */

export function getFormsWithCustomCode() {
  const request = () => {
    return { type: GET_CUSTOM_CODE_FORMS_REQUEST };
  };
  const success = (res) => {
    return { type: GET_CUSTOM_CODE_FORMS_SUCCESS, payload: res };
  };
  const failure = () => {
    return { type: GET_CUSTOM_CODE_FORMS_FAILURE };
  };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getFormsWithCustomCode();

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

export function markFormWithCustomCodeAsChecked(formId) {
  const request = () => {
    return { type: MARK_FORM_WITH_CUSTOM_CODE_AS_CHECKED_REQUEST };
  };
  const success = (res) => {
    return { type: MARK_FORM_WITH_CUSTOM_CODE_AS_CHECKED_SUCCESS, payload: res };
  };
  const failure = () => {
    return { type: MARK_FORM_WITH_CUSTOM_CODE_AS_CHECKED_FAILURE };
  };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.markFormWithCustomCodeAsChecked({ formId });

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}
